"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CameraBlank = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var CameraBlank = function CameraBlank() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.486 22.859l-.606.606a.571.571 0 01-.8 0l-3.646-3.646a2.286 2.286 0 01-1.634.754H3.086A2.286 2.286 0 01.8 18.287V6.86a2.286 2.286 0 012.286-2.286L1.303 2.722a.549.549 0 010-.8l.64-.606a.549.549 0 01.8 0l20.743 20.777a.571.571 0 010 .766zm-4.4-8L8.8 4.573h8a2.286 2.286 0 012.286 2.286v3.428l3.097-3.097c.213-.21.5-.33.8-.331h.103c.315 0 .571.256.571.571v10.286a.572.572 0 01-.571.571h-.103c-.3 0-.587-.12-.8-.331l-3.097-3.097zM7.85 9.282l1.92 1.828-.045.046a.549.549 0 01-.355.137H4.8a.571.571 0 01-.571-.571v-.869c0-.316.255-.571.57-.571h3.052z",
    clipRule: "evenodd"
  }), react_1.default.createElement("path", {
    stroke: "#EE0007",
    d: "M23.473 22.775l.006.006.006.005a.045.045 0 01.011.016.049.049 0 01-.011.055l-.006.005-.006.006-.605.605-.006.006-.005.006a.05.05 0 01-.016.011l.198.459-.198-.459a.05.05 0 01-.039 0l-.199.459.199-.459a.049.049 0 01-.016-.011l-.006-.006-.006-.006-3.759-3.748h0L6.56 7.27h0L.527 1.225.521 1.22l-.006-.006a.049.049 0 01-.011-.016l-.455.197.455-.197a.048.048 0 01.011-.055l.006-.005.006-.006.605-.605.006-.006.005-.006a.048.048 0 01.055-.011l.196-.452-.196.452a.048.048 0 01.016.011l.005.006.006.006 22.248 22.248z"
  }));
};

exports.CameraBlank = CameraBlank;